<router-outlet></router-outlet>
<!-- <app-chatting-box></app-chatting-box> -->
<nz-back-top class="ant-back-top" *ngIf="(currentWindowWidth$ | async) > 500" [nzVisibilityHeight]="100">
    <nz-back-top class="ant-back-top2" *ngIf="(currentWindowWidth$ | async) <= 500"
        [nzVisibilityHeight]="100"></nz-back-top>
</nz-back-top>